import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowBoxRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowBoxRight"><Path fillRule="evenodd" clipRule="evenodd" d="M13.6525 2.79248L20.6525 2.79248V20.7925H13.6525V19.2925H19.1525V4.29248H13.6525V2.79248ZM11.1525 7.23184L15.7132 11.7925L11.1525 16.3532L10.0919 15.2925L12.8419 12.5425H2.65253V11.0425H12.8419L10.0919 8.2925L11.1525 7.23184Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowBoxRight;
